'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _typeof(obj) { return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EventEmitter = require('events');
var agent = require('./superagent');
var debug = require('debug')('syncdb:sync');

var Sync = (function (_EventEmitter) {
    _inherits(Sync, _EventEmitter);

    function Sync(driver, url, limit) {
        _classCallCheck(this, Sync);

        debug('new sync');

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Sync).call(this));

        _this._driver = driver;
        _this._url = url;
        _this._seqid = 0;
        _this._inserted = 0;
        _this._pushed = 0;
        _this._limit = limit;

        _this._promise = _this._start();
        _this._promise.catch(function (e) {
            // This check is needed, otherwise it will throw an exception if
            // there is no error listener
            if (_this.listenerCount('error') > 0) {
                _this.emit('error', e);
            }
        });
        _this.then = _this._promise.then.bind(_this._promise);
        return _this;
    }

    _createClass(Sync, [{
        key: '_start',
        value: function _start() {
            var _this2 = this;

            debug('start sync');
            // Get last local seqid
            return this._driver.getLastSeqid().then(function (id) {
                _this2._seqid = id;
                var infoUrl = _this2._url + '/info?since=' + id;
                // Get remaining sync steps from server
                return agent.get(infoUrl).end().then(function (result) {
                    _this2.emit('info', result.body.data);
                    return _this2._fetch();
                });
            });
        }
    }, {
        key: '_fetch',
        value: function _fetch() {
            var _this3 = this;

            debug('_fetch');
            var url = this._url + '?since=' + this._seqid + '&limit=' + this._limit;
            return agent.get(url).end().then(function (response) {
                var result = response.body.data;
                if (result.length === 0) {
                    return _this3._push();
                }
                var i = 0;
                var insertNext = function insertNext() {
                    if (result.length > i) {
                        var _ret = (function () {
                            var res = result[i++];
                            return {
                                v: _this3._insert(res).then(function () {
                                    _this3._seqid = res.seqid;
                                    _this3._inserted++;
                                    _this3.emit('progress', res);
                                    return insertNext();
                                })
                            };
                        })();

                        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
                    } else {
                        return _this3._fetch();
                    }
                };
                return insertNext();
            });
        }
    }, {
        key: '_insert',
        value: function _insert(data) {
            var _this4 = this;

            debug('_insert');
            return this._driver.get(data.id).then(function (doc) {
                var toInsert = {
                    id: data.id,
                    seqid: data.seqid,
                    revid: 0,
                    date: data.date,
                    value: data.value
                };
                if (doc && doc.seqid !== data.seqid) {
                    return nextIDForConflict(doc.id, _this4._driver, 0).then(function (id) {
                        var docBackup = {
                            id: id,
                            seqid: -1,
                            revid: 0,
                            date: doc.date,
                            value: doc.value
                        };
                        return _this4._driver.insert(docBackup).then(function () {
                            return _this4._driver.insert(toInsert);
                        });
                    });
                } else {
                    return _this4._driver.insert(toInsert);
                }
            });
        }
    }, {
        key: '_push',
        value: function _push() {
            var _this5 = this;

            debug('_push');
            return this._driver.getRevData().then(function (data) {
                var url = _this5._url + '/update';
                var i = 0;
                var pushNext = function pushNext() {
                    if (data.length > i) {
                        var _ret2 = (function () {
                            var obj = data[i++];
                            var toPush = {
                                id: obj.id,
                                seqid: obj.seqid,
                                date: obj.date,
                                state: 'update',
                                value: obj.value
                            };
                            return {
                                v: agent.post(url).send(toPush).end().then(function (response) {
                                    toPush.seqid = response.body.data.seqid;
                                    return _this5._driver.insert(toPush).then(function () {
                                        _this5._pushed++;
                                        return pushNext();
                                    });
                                }, function (e) {
                                    if (e.status === 409) {
                                        return _this5._fetch();
                                    }
                                    return Promise.reject(e);
                                })
                            };
                        })();

                        if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
                    } else {
                        return _this5._end();
                    }
                };
                return pushNext();
            });
        }
    }, {
        key: '_end',
        value: function _end() {
            debug('end sync');
            var resInfo = {
                inserted: this._inserted,
                pushed: this._pushed
            };
            this.emit('end', resInfo);
            return resInfo;
        }
    }]);

    return Sync;
})(EventEmitter);

module.exports = Sync;

function nextIDForConflict(currentID, driver, it) {
    if (it === undefined) it = 0;
    var id = currentID + '_' + it;
    return driver.get(id).then(function (data) {
        if (!data) return id;else return nextIDForConflict(currentID, driver, ++it);
    });
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/sync-db/lib/sync.js
 ** module id = 2
 ** module chunks = 0
 **/